import React from 'react'
import { BestIcon, FeatIcon } from '../../../../../../../core/global/Icons'
import { Avatar, Box, Button, Divider, Typography } from '@mui/material'
import { CallOutlined, Facebook } from "@mui/icons-material"
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';

export const Info = ({ viewdata }) => {
	const dsginfo = viewdata.data

	return (
		<Box width="100%" height="100%" px={3}>
			<Typography width="100%" fontSize={72} fontWeight={600} color="#313131" >{dsginfo.content.title}</Typography>
			<Box width={600} fontSize={16} fontWeight={400} color="#6A6A6A">{dsginfo.content.title_description}</Box>
			<Box width="100%" display="flex" alignItems="center" py={2}>
				<Box fontSize={32} fontWeight={700} color="#313131">{dsginfo.content.start_price}</Box>
				<Box fontSize={32} fontWeight={700} color="#ED9140">₱ {dsginfo.content.price}</Box>
			</Box>

			<Box display="flex" alignItems="center" gap={2}>
				<Box sx={{ ':hover': { border: "#009F4D solid 2px", p: 1 } }} >
					<Button sx={{
						fontSize: 14, fontWeight: 500, color: "#FFFFFF", bgcolor: "#ED9140",
						border: `solid 2px`, height: '52px', width: '180px', ':hover': { color: "#363535" }
					}}
					>{dsginfo.content.buttons.second.label}</Button>
				</Box>
			</Box>

			<Box display="flex" alignItems="center" my={6} gap={2}>
				<Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
				<Typography display="flex" alignItems="center" fontSize={14} color="#e3e3e3" gap={3}><Box>#</Box><Box>#</Box><Box>#</Box></Typography>
				<Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
			</Box>
			
				<Box width="100%" bgcolor="#FBF8F7" borderRadius={3} p="32px" gap="10px">
					<Box display="flex" alignItems="center">
						<BestIcon />
						<Box pl={1} fontSize={24} fontWeight={600} color="#313131">{dsginfo.content.bestfor_title} :</Box>
					</Box>
					<Box width="100%" pl={1} pt={1} display="flex" alignItems="center" flexWrap="wrap">
						{dsginfo.content.bestfor_items.map((i, k) => (
							<Box key={k} width="50%" fontSize={16} fontWeight={400} color="#313131">•  {i} </Box>
						))}
					</Box>
				</Box>

			
				<Box mt={2} width="100%" bgcolor="#FBF8F7" borderRadius={3} p="32px" gap="10px">
					<Box display="flex" alignItems="center">
						<FeatIcon />
						<Box pl={1} fontSize={24} fontWeight={600} color="#313131"> {dsginfo.content.feature_title} : </Box>
					</Box>
					<Box width="100%" pl={1} pt={1} display="flex" alignItems="center" flexWrap="wrap">
						{dsginfo.content.feature_items.map((i, k) => (
							<Box fontSize={16} fontWeight={400} color="#313131" key={k} width="50%">•  {i}</Box>
						))}
					</Box>
				</Box>
			

			<Box px={3} display="flex" alignItems="center" my={6} gap={2}>
				<Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
				<Typography display="flex" alignItems="center" fontSize={14} color="#e3e3e3"gap={3}><Box>#</Box><Box>#</Box><Box>#</Box></Typography>
				<Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
			</Box>
			<Box>
				<Typography fontSize={24} fontWeight={600} color="#313131"  >{dsginfo.content.atp_title}</Typography>
				<Typography fontSize={16} fontWeight={400} color="#6A6A6A" >{dsginfo.content.atp_description}</Typography>
				{/* <Typography pt={1} sx={{cursor: 'pointer', fontSize: 16, fontWeight: 600, color: "#313131", ":hover": {borderBottom: "solid 1px", pt: 1, width: 100,} }}>Read more...</Typography> */}
			</Box>

			<Box display="flex" alignItems="center" my={6} gap={2}>
				<Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
				<Typography display="flex" alignItems="center" fontSize={14} color="#e3e3e3"gap={3}><Box>#</Box><Box>#</Box><Box>#</Box></Typography>
				<Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
			</Box>

			<Box display="flex" >
				<Box component="label" sx={{ cursor: 'pointer' }}>
					<Avatar sx={{ width: 72, height: 72 }} alt={dsginfo.content.images.owner_img} src={dsginfo.content.images.owner_img} />
				</Box>
				<Box px={1}>
					<Box width="100%" fontSize={20} fontWeight={600} color="#313131" >{dsginfo.content.owner_name}</Box>
					<Box width="100%" fontSize={16} fontWeight={400} color="#ED9140">{dsginfo.content.owner_title}</Box>
				    <Typography pt={2} width="100%" fontSize={16} fontWeight={400} color="#313131" >{dsginfo.content.owner_description}</Typography>
				</Box>
			</Box>
			<Box display="flex" alignItems="center" my={6} gap={2}>
				<Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
				<Typography display="flex" alignItems="center" fontSize={14} color="#e3e3e3"gap={3}><Box>#</Box><Box>#</Box><Box>#</Box></Typography>
				<Divider sx={{ width: "44%", border: "solid 1px #e3e3e3", borderRadius: 2 }} />
			</Box>

			<Box fontSize={24} fontWeight={600} color="#313131">{dsginfo.content.contact_title}</Box>
			<Box display="flex" pt={1} gap={2}>
				<Box display="flex" alignItems="center"
					fontSize={16} fontWeight={400} color="#313131"><PhoneIphoneIcon sx={{ color: '#999797', fontSize: 24 }} />{dsginfo.content.cellphone_num}</Box>
				<Box px={3} display="flex" alignItems="center" fontSize={16} fontWeight={400} color="#313131" ><CallOutlined sx={{ color: '#999797', fontSize: 24, mr: 2 }} />{dsginfo.content.telephone_num}</Box>
			</Box>
			<Box width="100%" pt={3} fontSize={24} fontWeight={600} color="#313131">{dsginfo.content.social_title}</Box>

			<Box width={200} pt={1}>
				<Box display="flex" alignItems="center">
					<Facebook sx={{ color: "#ED9140", fontSize: 30, borderRadius: 64, cursor: "pointer" }} />
					<InstagramIcon sx={{ color: "#ED9140", fontSize: 30, borderRadius: 64, mx: 3, cursor: "pointer" }} />
					<TwitterIcon sx={{ color: "#ED9140", fontSize: 30, borderRadius: 64, cursor: "pointer" }} />
				</Box>
			</Box>
		</Box>
	)
}
